// Comprehensive mock data showing all possible offer features
export const mockOfferData = {
  id: "mock-offer-123",
  title: "Konferencja Biznesowa z Programem Integracyjnym",
  description:
    "Kompleksowa oferta dla firmy kukla.tech obejmująca 3-dniową konferencję biznesową z programem integracyjnym, warsztatami, imprezą wieczorną i pełnym wyżywieniem. Kukla.tech to innowacyjna firma technologiczna, która stworzyła system HotelB2B - platformę do zarządzania ofertami hotelowymi dla biznesu.",
  clientName: "kukla.tech",
  clientEmail: "contact@kukla.tech",
  clientPhone: "+48 691 059 529",
  checkInDate: "2025-05-15",
  checkOutDate: "2025-05-17",
  numberOfRooms: 25,
  numberOfGuests: 50,
  netValue: 87500,
  totalDiscount: 7500,
  publishedAt: "2025-04-08T17:00:00Z",
  createdAt: "2025-04-01T10:00:00Z",
  hotel: {
    name: "Hotel Conference & Spa",
    address: "ul. Biznesowa 123, 00-001 Warszawa",
    phone: "+48 22 123 45 67",
    email: "konferencje@hotelconference.pl",
    website: "www.hotelconference.pl",
  },
  offerDays: [
    {
      id: "day-1",
      date: "2025-05-15",
      dayNumber: 1,
      planItems: [
        {
          id: "item-1-1",
          timeFrom: "14:00",
          timeTo: "15:00",
          quantity: 25,
          unitPrice: 0,
          finalPrice: 0,
          customTitle: "Zameldowanie",
          notes: "Pokoje dostępne od godziny 14:00",
          categoryOption: {
            name: "Pokój Business Double",
            optionType: "accommodation",
          },
        },
        {
          id: "item-1-2",
          timeFrom: "15:00",
          timeTo: "15:30",
          quantity: 50,
          unitPrice: 15,
          finalPrice: 750,
          customTitle: "Powitalna kawa z ciasteczkami",
          notes: "Serwowane w lobby hotelu",
          categoryOption: {
            name: "Kawa/herbata z ciasteczkami",
            optionType: "gastronomy",
          },
        },
        {
          id: "item-1-3",
          timeFrom: "15:30",
          timeTo: "17:00",
          quantity: 50,
          unitPrice: 85,
          finalPrice: 4250,
          customTitle: "Otwarcie konferencji - sala główna",
          notes:
            "Prezentacja strategii na 2025 rok. Potrzebny sprzęt AV: projektor, mikrofon bezprzewodowy, flipchart",
          categoryOption: {
            name: "Sala konferencyjna Grand (do 80 osób)",
            optionType: "conference",
          },
        },
        {
          id: "item-1-4",
          timeFrom: "17:00",
          timeTo: "17:30",
          quantity: 50,
          unitPrice: 20,
          finalPrice: 1000,
          customTitle: "Przerwa kawowa",
          notes: "Kawa, herbata, woda, owoce sezonowe",
          categoryOption: {
            name: "Coffee break - pakiet premium",
            optionType: "gastronomy",
          },
        },
        {
          id: "item-1-5",
          timeFrom: "17:30",
          timeTo: "19:00",
          quantity: 50,
          unitPrice: 120,
          finalPrice: 6000,
          customTitle: "Warsztaty w grupach - 3 sale",
          notes:
            "Grupa A: Zarządzanie projektami (sala Apollo)\nGrupa B: Komunikacja w zespole (sala Venus)\nGrupa C: Innowacje technologiczne (sala Mars)",
          categoryOption: {
            name: "Pakiet 3 sal warsztatowych",
            optionType: "conference",
          },
        },
        {
          id: "item-1-6",
          timeFrom: "19:30",
          timeTo: "22:00",
          quantity: 50,
          unitPrice: 180,
          finalPrice: 9000,
          customTitle: "Kolacja powitalna z programem artystycznym",
          notes: "Menu 3-daniowe + napoje + występ zespołu jazzowego",
          categoryOption: {
            name: "Kolacja biznesowa - menu premium",
            optionType: "gastronomy",
          },
        },
      ],
    },
    {
      id: "day-2",
      date: "2025-05-16",
      dayNumber: 2,
      planItems: [
        {
          id: "item-2-1",
          timeFrom: "07:00",
          timeTo: "09:00",
          quantity: 50,
          unitPrice: 65,
          finalPrice: 3250,
          customTitle: "Śniadanie szwedzki stół",
          notes: "Pełny szwedzki stół w restauracji głównej",
          categoryOption: {
            name: "Śniadanie - szwedzki stół",
            optionType: "gastronomy",
          },
        },
        {
          id: "item-2-2",
          timeFrom: "09:00",
          timeTo: "10:30",
          quantity: 50,
          unitPrice: 95,
          finalPrice: 4750,
          customTitle: "Sesja plenarna - keynote speaker",
          notes:
            "Dr. Anna Kowalska - 'Przyszłość technologii w biznesie'. Potrzebny sprzęt: nagłośnienie, projektor 4K, streaming online",
          categoryOption: {
            name: "Sala konferencyjna Grand - pakiet premium AV",
            optionType: "conference",
          },
        },
        {
          id: "item-2-3",
          timeFrom: "10:30",
          timeTo: "11:00",
          quantity: 50,
          unitPrice: 25,
          finalPrice: 1250,
          customTitle: "Przerwa networkingowa",
          notes: "Rozszerzona przerwa z przekąskami i owocami",
          categoryOption: {
            name: "Coffee break - pakiet networking",
            optionType: "gastronomy",
          },
        },
        {
          id: "item-2-4",
          timeFrom: "11:00",
          timeTo: "12:30",
          quantity: 50,
          unitPrice: 75,
          finalPrice: 3750,
          customTitle: "Panel dyskusyjny - liderzy branży",
          notes:
            "Moderator + 4 panelistów. Tematy: transformacja cyfrowa, zrównoważony rozwój",
          categoryOption: {
            name: "Sala konferencyjna Grand - setup panel",
            optionType: "conference",
          },
        },
        {
          id: "item-2-5",
          timeFrom: "12:30",
          timeTo: "14:00",
          quantity: 50,
          unitPrice: 95,
          finalPrice: 4750,
          customTitle: "Lunch biznesowy",
          notes: "Menu 2-daniowe + napoje + kawa",
          categoryOption: {
            name: "Lunch biznesowy - menu sezonowe",
            optionType: "gastronomy",
          },
        },
        {
          id: "item-2-6",
          timeFrom: "14:00",
          timeTo: "16:00",
          quantity: 25,
          unitPrice: 150,
          finalPrice: 3750,
          customTitle: "Aktywność outdoor - teambuilding",
          notes:
            "Paintball lub escape room (do wyboru). Transport busem w cenie. Ubezpieczenie NNW włączone",
          categoryOption: {
            name: "Pakiet teambuilding - aktywność outdoor",
            optionType: "entertainment",
          },
        },
        {
          id: "item-2-7",
          timeFrom: "16:00",
          timeTo: "17:00",
          quantity: 25,
          unitPrice: 45,
          finalPrice: 1125,
          customTitle: "Relaks w SPA",
          notes: "Dostęp do basenu, sauny i jacuzzi. Ręczniki w cenie",
          categoryOption: {
            name: "Pakiet SPA - 1h relaksu",
            optionType: "entertainment",
          },
        },
        {
          id: "item-2-8",
          timeFrom: "19:00",
          timeTo: "23:00",
          quantity: 50,
          unitPrice: 250,
          finalPrice: 12500,
          customTitle: "Gala dinner z nagrodami",
          notes:
            "Menu degustacyjne 5-dań + wina + ceremonia wręczenia nagród + DJ",
          categoryOption: {
            name: "Gala dinner - pakiet premium",
            optionType: "gastronomy",
          },
        },
      ],
    },
    {
      id: "day-3",
      date: "2025-05-17",
      dayNumber: 3,
      planItems: [
        {
          id: "item-3-1",
          timeFrom: "07:30",
          timeTo: "09:00",
          quantity: 50,
          unitPrice: 65,
          finalPrice: 3250,
          customTitle: "Śniadanie pożegnalne",
          notes: "Śniadanie w formie bufetu + świeże soki",
          categoryOption: {
            name: "Śniadanie - szwedzki stół",
            optionType: "gastronomy",
          },
        },
        {
          id: "item-3-2",
          timeFrom: "09:00",
          timeTo: "10:30",
          quantity: 50,
          unitPrice: 65,
          finalPrice: 3250,
          customTitle: "Sesja podsumowująca",
          notes: "Wnioski z konferencji + planowanie działań na przyszłość",
          categoryOption: {
            name: "Sala konferencyjna Grand - podstawowy AV",
            optionType: "conference",
          },
        },
        {
          id: "item-3-3",
          timeFrom: "10:30",
          timeTo: "11:00",
          quantity: 50,
          unitPrice: 20,
          finalPrice: 1000,
          customTitle: "Pożegnalna kawa",
          notes: "Kawa + mini deserki + pakiety na drogę",
          categoryOption: {
            name: "Coffee break - pakiet pożegnalny",
            optionType: "gastronomy",
          },
        },
        {
          id: "item-3-4",
          timeFrom: "11:00",
          timeTo: "12:00",
          quantity: 25,
          unitPrice: 0,
          finalPrice: 0,
          customTitle: "Wymeldowanie",
          notes:
            "Możliwość późnego wymeldowania do 12:00. Przechowalnia bagażu dostępna do 16:00",
          categoryOption: {
            name: "Pokój Business Double",
            optionType: "accommodation",
          },
        },
      ],
    },
  ],
};

// Additional mock options for comprehensive display
export const mockBrandKit = {
  colors: {
    primary: "#1E40AF", // Blue
    secondary: "#6B7280", // Gray
    accent: "#059669", // Green
  },
  keyVisualUrl:
    "https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
};

export const mockTermsAndConditions = {
  enabled: true,
  content: `• Ceny obowiązują do 30 kwietnia 2025 roku
• Wymagana przedpłata 50% wartości oferty w terminie 14 dni od potwierdzenia
• Pozostała kwota płatna przy zameldowaniu
• Możliwość bezpłatnej anulacji do 7 dni przed przyjazdem
• W przypadku późniejszej anulacji pobierana jest opłata w wysokości 30% wartości oferty
• Ceny zawierają podatek VAT 23%
• Menu może zostać dostosowane do specjalnych wymagań dietetycznych (informacja 72h wcześniej)
• Hotel zastrzega sobie prawo do zmian w menu ze względu na dostępność składników sezonowych
• Parking dla uczestników konferencji bezpłatny (25 miejsc)
• WiFi w całym hotelu bez ograniczeń transferu`,
};
